import { without } from '@/globals';

import * as types from './mutation-types';

const makeSetStateMutation = (stateField) => (state, value) => {
  state[stateField] = value;
};

const mutations = {
  //
  // AVAILS
  //
  [types.SET_AVAILS]: makeSetStateMutation('avails'),

  //
  // DEMOGRAPHICS
  //
  [types.SET_DEMOGRAPHICS]: makeSetStateMutation('demographics'),

  //
  // EXCHANGE
  //
  [types.SET_EXCHANGE]: makeSetStateMutation('exchange'),
  [types.SET_EXCHANGE_SETTINGS]: makeSetStateMutation('exchangeSettings'),
  [types.SET_SUPPLIERS]: makeSetStateMutation('suppliers'),

  //
  // GEOFENCE GROUPS
  //
  [types.SET_GEOFENCE_GROUPS]: makeSetStateMutation('geofenceGroups'),

  //
  // LANGUAGES
  //
  [types.SET_LANGUAGES]: makeSetStateMutation('languages'),

  //
  // LOCATIONS
  //
  [types.SET_LOCATIONS]: makeSetStateMutation('locations'),
  [types.SET_LOCATIONS_EXCLUDED]: makeSetStateMutation('locationsExcluded'),

  //
  // LINEITEMS
  //
  [types.SET_LINEITEM]: makeSetStateMutation('lineItem'),
  [types.SET_LINEITEMS]: makeSetStateMutation('lineItems'),
  [types.SET_TOTAL_LINEITEMS]: makeSetStateMutation('totalLineItems'),

  //
  // MARKETS
  //
  [types.SET_MARKETS]: makeSetStateMutation('markets'),

  //
  // MEDIA_TYPES
  //
  [types.SET_MEDIA_TYPES]: makeSetStateMutation('mediaTypes'),

  //
  // NETWORKS
  //
  [types.SET_NETWORKS]: makeSetStateMutation('networks'),

  //
  // ORGANIZATION DSPS
  //
  [types.SET_ORGANIZATION_DSPS]: makeSetStateMutation('organizationDSPs'),

  //
  // PACKAGES
  //
  [types.SET_PACKAGE]: makeSetStateMutation('package'),
  [types.SET_PACKAGES]: makeSetStateMutation('packages'),
  [types.SET_TOTAL_PACKAGES]: makeSetStateMutation('totalPackages'),
  [types.UPDATE_PACKAGES](state, packs) {
    if (!Array.isArray(packs)) {
      packs = [packs];
    }
    packs.forEach((pack) => {
      if (state.package && state.package.id === pack.id) {
        state.package = pack;
      }

      const idx = (state.packages || []).findIndex((x) => x.id === pack.id);
      if (idx > -1) {
        state.packages[idx] = pack;
      }
    });
  },
  [types.DELETE_PACKAGE](state, pack) {
    state.packages = without(state.packages, pack);
  },

  //
  // PERMISSIONS
  //
  [types.SET_PERMISSIONS]: makeSetStateMutation('permissions'),

  //
  // SITES
  //
  [types.SET_SITES]: makeSetStateMutation('sites'),
  [types.SET_SITES_EXCLUDED]: makeSetStateMutation('sitesExcluded'),

  //
  // TARGETING CRITERIA
  //
  [types.SET_TARGETING_CRITERIA]: makeSetStateMutation('targetingCriteria'),

  //
  // UNITS
  //
  [types.SET_UNITS]: makeSetStateMutation('units'),
  [types.SET_UNITS_EXCLUDED]: makeSetStateMutation('unitsExcluded'),
};

export default mutations;
